import{ ReactNode } from 'react';
import { Composer, Wrapper } from '@teambit/base-ui.utils.composer';

export declare type GlobalContextsType = Wrapper<any>[];

export declare interface AppComposerProps {
  /**
   * @example const globalContexts = [StoreProvider, [IntlProvider, { apiService, supportedLocales }]];
   */
  globalContexts: GlobalContextsType;
  /**
   * a node to be rendered in the special component.
   */
  children?: ReactNode;
};

export function AppComposer({ globalContexts, children }: AppComposerProps) {
  return <Composer components={globalContexts}>{children}</Composer>;
}
